import React from "react";
import { withStyles } from "@material-ui/core";
import { withRouter } from "react-router-dom";
import { get, size, map, sum } from "lodash";
import clsx from "clsx";

import Grid from "@material-ui/core/Grid";
import TableRow from "@material-ui/core/TableRow";

import TableCellStyled from "../Common/TableCellStyled";

import colors from "../../assets/style/colors";
import images from "../../assets/img/images";

const styles = {
  dataCell: {
    color: colors.black54,
  },
  arrowItem: {
    width: "12px",
    marginRight: "12px",
    cursor: "pointer",
  },
  indented: {
    paddingLeft: "50px !important",
  },
  bottomBorder: {
    borderBottom: `1px solid ${colors.veryLighPink}`,
  },
  link: {
    color: colors.primary,
    cursor: "pointer",
    "&:hover": {
      textDecoration: "underline",
    },
  },
  tableRowHover: {
    "&:hover": {
      backgroundColor: colors.lightGreenBg + " !important",
    },
  },
};

const CompanyDevicesRow = withStyles(styles)((props) => {
  const {
    classes,
    item,
    language,
    levelId,
    isLast,
    index,
    companyName,
  } = props;
  const [expanded, setExpanded] = React.useState(false);

  const hasChilds = size(get(item, ["devices"])) > 0;
  const borderBottomCondition = (levelId === 0 && !expanded) || isLast;

  const getZones = () => {
    let res = get(item, ["zone_branch", "zone_name"]);
    let subZone = get(item, ["zone_branch", "zone"]);
    while (subZone) {
      res += `, ${get(subZone, ["zone_name"])}`;
      subZone = get(subZone, ["zone"]);
    }
    return res;
  };

  const goTo = () => {
    const url = `/admin/companies/${get(item, ["company_id"])}/sites/${get(
      item,
      ["site", "site_id"]
    )}/zones/${get(item, ["zone_branch", "zone_id"])}/devices/${get(item, [
      "id",
    ])}/details`;
    props.history.push(url);
  };

  return (
    <>
      <TableRow
        style={{
          cursor: hasChilds ? "pointer" : "",
          backgroundColor:
            index % 2 === 1 || levelId === 0
              ? colors.white
              : colors.tableDarkBg,
        }}
        hover={true}
        classes={{ hover: classes.tableRowHover }}
        onClick={() => (hasChilds ? setExpanded(!expanded) : null)}
      >
        <TableCellStyled
          className={clsx(classes.dataCell, {
            [classes.indented]: levelId > 0,
            [classes.bottomBorder]: borderBottomCondition,
          })}
        >
          <Grid container alignItems="center" wrap="nowrap">
            {hasChilds && (
              <Grid
                item
                className={classes.arrowItem}
                onClick={() => setExpanded(!expanded)}
              >
                <img
                  src={
                    expanded ? images.arrowOpenBlack : images.arrowClosedBlack
                  }
                  height="10px"
                  style={{ maxWidth: "10px" }}
                  alt="arrow"
                />
              </Grid>
            )}
            <Grid item className={classes.link} onClick={goTo}>{`${get(item, [
              "name",
            ])} ${hasChilds ? `(${size(get(item, ["devices"]))})` : ""}`}</Grid>
          </Grid>
        </TableCellStyled>
        <TableCellStyled
          className={clsx(classes.dataCell, {
            [classes.bottomBorder]: borderBottomCondition,
          })}
        >
          {get(item, [`device_type_name_${language}`])}
        </TableCellStyled>
        <TableCellStyled
          className={clsx(classes.dataCell, {
            [classes.bottomBorder]: borderBottomCondition,
          })}
        >
          {companyName}
        </TableCellStyled>
        <TableCellStyled
          className={clsx(classes.dataCell, {
            [classes.bottomBorder]: borderBottomCondition,
          })}
        >
          {get(item, ["site", "site_name"])}
        </TableCellStyled>
        <TableCellStyled
          className={clsx(classes.dataCell, {
            [classes.bottomBorder]: borderBottomCondition,
          })}
        >
          {hasChilds ? "-" : getZones(item)}
        </TableCellStyled>
      </TableRow>
      {expanded &&
        map(get(item, ["devices"]), (d, index) => (
          <CompanyDevicesRow
            key={d.id}
            item={d}
            language={language}
            levelId={sum([levelId, 1])}
            isLast={size(get(item, ["devices"])) === index + 1}
            index={index}
            companyName={companyName}
          />
        ))}
    </>
  );
});

export default withRouter(CompanyDevicesRow);
